import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { PatientService } from '../../patient/patient.service';
import { environment } from '../../../../environments/environment';
import { MessagingService } from '../../../services/messaging.service';
import { Globals } from '../../../globals';


@Component({
  selector: 'app-patient-find',
  templateUrl: './patient-find.component.html',
  styleUrls: ['./patient-find.component.css']
})
export class PatientFindComponent implements OnInit {

  isSearching: boolean = false;
  searchCriteria: string = "";
  patientList: any;
  searchSubscription: any;
  error: string;
  errorTimeout: any;

  constructor(
    public dialogRef: MatDialogRef<PatientFindComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private patientService: PatientService,
    private messagingService: MessagingService,
    public globals: Globals,
  ) { }

  ngOnInit() {
    if (this.data !== null || this.data !== undefined) {
      if (this.data.hasOwnProperty('searchString')) {
        this.searchCriteria = this.data.searchString;

        this.onFindTextChange("");
      }
    }
  }

  onFindTextChange(event: any) {

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
      this.searchSubscription = false;
      this.isSearching = false;
    }

    const searchText: string = this.searchCriteria.trim();

    if (!searchText) {
      this.isSearching = false;
      this.patientList = null;
      return;
    }

    this.isSearching = true;
    this.searchSubscription = this.patientService.searchForPatient(searchText).subscribe(data => {
      if (searchText) {
        this.patientList = data.SearchResults;
        this.searchSubscription = false;
        this.isSearching = false;
      }
    }, (err: any) => {
      console.log('error', err);
      if (err.status !== 404) {
        this.addErrorMessage('Something went wrong with the search, please try again');
      }
      this.searchSubscription = false;
      this.patientList = [];
      this.isSearching = false;
    });
  }

  onClickButtonClear() {
    this.searchCriteria = "";
    this.patientList = [];
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
      this.searchSubscription = false;
      this.isSearching = false;
    }
  }

  onClickButtonPatientSelected(event: any) {
    environment.CurrentPatient = event.PatientId;
    this.dialogRef.close(event.PatientId);
  }

  addErrorMessage(message) {
    this.error = message;
    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
    }

    this.errorTimeout = setTimeout(_ => {
      this.error = null;
      this.errorTimeout = null;
    }, 7000);
  }


}
